import ApiService from "../../Services/ApiService";

export default {
    state: {
        notificationUser: null,
        notifications: [],
        recentNotifications: [],
    },

    getters: {
        getNotificationUser(state) {
            return state.notificationUser;
        },
        getNotifications: (state) => {
            return state.notifications;
        },
        getRecentNotifications: (state) => {
            return state.recentNotifications;
        }
    },

    mutations: {
        setNotificationUser(state, payload) {
            state.notificationUser = payload;
        },
        setNotifications(state, payload) {
            state.notifications = payload.slice(0,2);
            state.recentNotifications = payload.slice(2);
        }
    },

    actions: {
        async loadNotifications({commit}, user_id) {
            const notifications = (await ApiService.getNotifications(user_id)).data;

            commit('setNotifications', notifications);
        },
        async loadExternalUserIdOnPlayerIdForDesktop({ commit }, data) {
            await ApiService.setExternalUserIdOnPlayerIdForDesktop(data);
        },
        async loadNotificationUserOnPlayerId({ commit }, player_id) {
            try {
                const notificationUser = (await ApiService.getNotificationUserOnPlayerId(player_id)).data;

                commit('setNotificationUser', notificationUser);
            } catch(error) {
                console.log(error.message);

                commit('setNotificationUser', null);
            }
        }
    },
};
